export default "__VITE_ASSET__DWgfRDcV__"